import { Box, Button, Card, CardContent, CardCover, Modal, ModalDialog, ModalOverflow, Sheet, Stack, Typography } from "@mui/joy";
import { useContext, useEffect, useState } from "react";

import EastRoundedIcon from '@mui/icons-material/EastRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';

import { motion, AnimatePresence } from "framer-motion";
import { LayoutContext } from "../context";
import { APIGetProfile, APIGetProfileStatus, APIUpdatePartnerPreferences } from "../api";


// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import { NAME_PROJECT, START_INFO_SHOWN_KEY } from "../utils";




export default function StartInfo() {
    const { modalStartInfo, setModalStartInfo } = useContext(LayoutContext);
    const [ swiper, setSwiper ] = useState(null);

    // Функция для закрытия окна и сохранения состояния
    const handleCloseStartInfo = () => {
        // Сохраняем в localStorage, что окно было показано
        localStorage.setItem(START_INFO_SHOWN_KEY, 'true');
        // localStorage.removeItem(START_INFO_SHOWN_KEY);
        setModalStartInfo({ open: false });
    };

    // localStorage.removeItem(START_INFO_SHOWN_KEY);
    // console.log("modalStartInfo", modalStartInfo);

    return (
        <AnimatePresence>
            {modalStartInfo?.open && (
                <Modal
                    sx={{ zIndex: 10022 }}
                    open={modalStartInfo?.open}
                    slotProps={{
                        backdrop: {
                            component: motion.div,
                            initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                            animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                            exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                            transition: { duration: 0.3, ease: "easeInOut" },
                        }
                    }}
                >
                    <ModalOverflow sx={{ height: 'auto' }}>
                        <ModalDialog
                            layout="fullscreen"
                            size="lg"
                            component={motion.div}
                            initial={{ opacity: 0, y: -10, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 10, scale: 0.98 }}
                            transition={{ duration: 0.2, ease: "easeInOut" }}
                            sx={(theme) => ({
                                [theme.breakpoints.up("xl")]: { width: '550px', mx: 0 },
                                [theme.breakpoints.down("xl")]: { width: '550px', mx: 0 },
                                [theme.breakpoints.down("lg")]: { width: '550px', mx: 0 },
                                [theme.breakpoints.down("md")]: { width: '450px', mx: 0 },
                                [theme.breakpoints.down("sm")]: { width: '95%' },
                                width: '100%',
                                p: 0
                            })}
                        >
                            {/* {profileStatus?.partner_preferences_complete && (
                                <ModalClose onClick={() => setModalStartInfo(prev => ({ ...prev, open: false }))}/>
                            )} */}

                            <Swiper
                                style={{ width: "100%", height: "100%" }}
                                modules={[Autoplay, Pagination, A11y]}
                                spaceBetween={0}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                // autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
                                onSwiper={(s) => {setSwiper(s)}}
                                // Сопротивление перетягивание
                                resistance={true}
                                resistanceRatio={0}
                            >
                                <SwiperSlide>
                                    <Stack sx={{ height: "100%" }} alignItems={'center'}>
                                        <Card sx={{ width: { xs: "100vw", sm: "50vw", sm2: "45vw", md: "35vw", lg: 400 }, height: "100%", p: 0, borderRadius: '0' }} variant="plain">
                                            <CardCover>
                                                <img src={"./slide/1.jpg"} style={{ width: '100%' }}/>
                                            </CardCover>
                                            <CardCover
                                                sx={{ background: 'linear-gradient(to top, rgba(0,0,0,0.2), rgba(0,0,0,0.1) 100%)' }}
                                            />
                                            <CardContent
                                                sx={(theme) => ({
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'flex-start',
                                                    px: 2,
                                                    py: 6,
                                                })}
                                            >
                                                {/* <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", height: "100%" }}>
                                                    <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", pt: 11 }}>
                                                        <Stack direction={"column"} sx={{ zIndex: 2, alignItems: "center", pb: 0 }} position={'relative'}>
                                                            <Box
                                                                sx={{ 
                                                                    width: 140,
                                                                    height: 140,
                                                                    borderRadius: '50%',
                                                                    // backgroundColor: 'primary.100',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                            >
                                                                <img className="heart-puls" style={{ width: 170, zIndex: 3, opacity: 1 }} src='./logo.png' />
                                                            </Box>
                                                            <Typography sx={{ textAlign: 'center', zIndex: 1, mt: 3, color: 'primary.200' }} level="h2">
                                                                {NAME_PROJECT?.toUpperCase()}
                                                            </Typography>
                                                        </Stack>

                                                        <Typography sx={{ color: "white", textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h3">
                                                            Для тех, кто ищет и находит любовь, поддержку и родные души
                                                        </Typography>

                                                        <Typography sx={{ color: 'neutral.100', gap: 1, pt: 3, textAlign: "center" }} level="body-sm">
                                                            {NAME_PROJECT?.toUpperCase()} от слова “неразлучники”. Это русское приложение, где судьбы переплетаются, а не просто ставятся лайки. Безопасно, серьезно и на долгий срок.
                                                        </Typography>
                                                    </Stack>
                                                </Stack> */}
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ mb: 1, width: "100%" }}>
                                                    <Button sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={handleCloseStartInfo}>
                                                        Начать
                                                    </Button>
                                                </Stack>
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%" }}>
                                                    <Button variant="soft" endDecorator={<EastRoundedIcon sx={{ fontSize: "30px" }} />} sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={() => swiper?.slideNext()}>
                                                        Далее
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <Stack sx={{ height: "100%" }} alignItems={'center'}>
                                        <Card sx={{ width: { xs: "100vw", sm: "50vw", sm2: "45vw", md: "35vw", lg: 400 }, height: "100%", p: 0, borderRadius: '0' }} variant="plain">
                                            <CardCover>
                                                <img src={"./slide/2.jpg"} style={{ width: '100%' }}/>
                                            </CardCover>
                                            <CardCover
                                                sx={{ background: 'linear-gradient(to top, rgba(0,0,0,0.2), rgba(0,0,0,0.1) 100%)' }}
                                            />
                                            <CardContent
                                                sx={(theme) => ({
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'flex-start',
                                                    px: 2,
                                                    py: 6,
                                                })}
                                            >
                                                {/* <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", height: "100%" }}>
                                                    <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", pt: 11 }}>
                                                        <Typography sx={{ color: "white", textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h2">
                                                            Для тех, кто ищет и находит любовь, поддержку и родные души
                                                        </Typography>

                                                        <Typography sx={{ color: 'neutral.100', gap: 1, pt: 3, textAlign: "center" }} level="body-sm">
                                                            {NAME_PROJECT?.toUpperCase()} от слова “неразлучники”. Это русское приложение, где судьбы переплетаются, а не просто ставятся лайки. Безопасно, серьезно и на долгий срок.
                                                        </Typography>
                                                    </Stack>
                                                </Stack> */}
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ mb: 1, width: "100%" }}>
                                                    <Button sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={handleCloseStartInfo}>
                                                        Начать
                                                    </Button>
                                                </Stack>
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%" }}>
                                                    <Button variant="soft" endDecorator={<EastRoundedIcon sx={{ fontSize: "30px" }} />} sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={() => swiper?.slideNext()}>
                                                        Далее
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <Stack sx={{ height: "100%" }} alignItems={'center'}>
                                        <Card sx={{ width: { xs: "100vw", sm: "50vw", sm2: "45vw", md: "35vw", lg: 400 }, height: "100%", p: 0, borderRadius: '0' }} variant="plain">
                                            <CardCover>
                                                <img src={"./slide/3.jpg"} style={{ width: '100%' }}/>
                                            </CardCover>
                                            <CardCover
                                                sx={{ background: 'linear-gradient(to top, rgba(0,0,0,0.2), rgba(0,0,0,0.1) 100%)' }}
                                            />
                                            <CardContent
                                                sx={(theme) => ({
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'flex-start',
                                                    px: 2, 
                                                    py: 6,
                                                })}
                                            >
                                                {/* <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", height: "100%" }}>
                                                    <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", pt: 11 }}>

                                                        <Typography sx={{ color: "white", textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h2">
                                                            Алгоритмы, которые чувствуют
                                                        </Typography>

                                                        <Typography sx={{ color: 'neutral.100', gap: 1, pt: 3, textAlign: "center" }} level="body-sm">
                                                            В мире, где время бежит быстрее чувств, находить родственную душу стало сложнее. Но не для тех, кто выбирает {NAME_PROJECT?.toUpperCase()}. Здесь умные технологии служат любви, а не заменяют ее.
                                                        </Typography>

                                                        <Sheet
                                                            color="primary"
                                                            variant="soft"
                                                            sx={{
                                                                // py: 1.5,
                                                                px: 2,
                                                                backgroundColor: "#ffffffbd",
                                                                borderRadius: 'xl'
                                                            }}
                                                        >
                                                            <Typography startDecorator={<FavoriteRoundedIcon sx={{ fontSize: "30px" }} color="danger" />} sx={{ color: 'neutral.500', gap: 1 }} level="body-sm">
                                                                <Stack component={"ul"} sx={{ listStyleType: "none", pl: 1 }}>
                                                                    <li>Глубокий анализ ваших интересов, внешности и характера.</li>
                                                                    <li>Удобный и понятный интерфейс.</li>
                                                                </Stack>
                                                            </Typography>
                                                        </Sheet>

                                                    </Stack>
                                                </Stack> */}
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ mb: 1, width: "100%" }}>
                                                    <Button sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={handleCloseStartInfo}>
                                                        Начать
                                                    </Button>
                                                </Stack>
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%" }}>
                                                    <Button variant="soft" endDecorator={<EastRoundedIcon sx={{ fontSize: "30px" }} />} sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={() => swiper?.slideNext()}>
                                                        Далее
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <Stack sx={{ height: "100%" }} alignItems={'center'}>
                                        <Card sx={{ width: { xs: "100vw", sm: "50vw", sm2: "45vw", md: "35vw", lg: 400 }, height: "100%", p: 0, borderRadius: '0' }} variant="plain">
                                            <CardCover>
                                                <img src={"./slide/4.jpg"} style={{ width: '100%' }}/>
                                            </CardCover>
                                            <CardCover
                                                sx={{ background: 'linear-gradient(to top, rgba(0,0,0,0.2), rgba(0,0,0,0.1) 100%)' }}
                                            />
                                            <CardContent
                                                sx={(theme) => ({
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'flex-start',
                                                    px: 2, 
                                                    py: 6,
                                                })}
                                            >
                                                {/* <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", height: "100%" }}>
                                                    <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", pt: 11 }}>
                                                        <Typography sx={{ color: "white", textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h2">
                                                            Создавайте связи и выигрывайте вместе
                                                        </Typography>

                                                        <Typography sx={{ color: 'neutral.100', gap: 1, pt: 3, textAlign: "center" }} level="body-sm">
                                                            Знакомьтесь, общайтесь, создавайте пары и целые сообщества! Участвуйте в розыгрышах невероятных призов — вплоть до собственной недвижимости. Постройте свою любовь буквально с нуля!
                                                        </Typography>
                                                    </Stack>
                                                </Stack> */}
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ mb: 1, width: "100%" }}>
                                                    <Button sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={handleCloseStartInfo}>
                                                        Начать
                                                    </Button>
                                                </Stack>
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%" }}>
                                                    <Button variant="soft" endDecorator={<EastRoundedIcon sx={{ fontSize: "30px" }} />} sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={() => swiper?.slideNext()}>
                                                        Далее
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <Stack sx={{ height: "100%" }} alignItems={'center'}>
                                        <Card sx={{ width: { xs: "100vw", sm: "50vw", sm2: "45vw", md: "35vw", lg: 400 }, height: "100%", p: 0, borderRadius: '0' }} variant="plain">
                                            <CardCover>
                                                <img src={"./slide/5.jpg"} style={{ width: '100%' }}/>
                                            </CardCover>
                                            <CardCover
                                                sx={{ background: 'linear-gradient(to top, rgba(0,0,0,0.2), rgba(0,0,0,0.1) 100%)' }}
                                            />
                                            <CardContent
                                                sx={(theme) => ({
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'flex-start',
                                                    px: 2, 
                                                    py: 6,
                                                })}
                                            >
                                                {/* <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", height: "100%" }}>
                                                    <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", pt: 11 }}>
                                                        <Typography sx={{ color: "white", textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h2">
                                                            Любовь без риска
                                                        </Typography>

                                                        <Typography sx={{ color: 'neutral.100', gap: 1, pt: 3, textAlign: "center" }} level="body-sm">
                                                            Ваша безопасность и конфиденциальность — наш главный приоритет. Верифицированные профили, модерация и современное шифрование данных. Знакомьтесь легко и уверенно.
                                                        </Typography>
                                                    </Stack>
                                                </Stack> */}
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ mb: 1, width: "100%" }}>
                                                    <Button sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={handleCloseStartInfo}>
                                                        Начать
                                                    </Button>
                                                </Stack>
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%" }}>
                                                    <Button variant="soft" endDecorator={<EastRoundedIcon sx={{ fontSize: "30px" }} />} sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={() => swiper?.slideNext()}>
                                                        Далее
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <Stack sx={{ height: "100%" }} alignItems={'center'}>
                                        <Card sx={{ width: { xs: "100vw", sm: "50vw", sm2: "45vw", md: "35vw", lg: 400 }, height: "100%", p: 0, borderRadius: '0' }} variant="plain">
                                            <CardCover>
                                                <img src={"./slide/6.jpg"} style={{ width: '100%' }}/>
                                            </CardCover>
                                            <CardCover
                                                sx={{ background: 'linear-gradient(to top, rgba(0,0,0,0.2), rgba(0,0,0,0.1) 100%)' }}
                                            />
                                            <CardContent
                                                sx={(theme) => ({
                                                    justifyContent: 'flex-end', 
                                                    alignItems: 'flex-start',
                                                    px: 2, 
                                                    py: 6,
                                                })}
                                            >
                                                {/* <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", height: "100%" }}>
                                                    <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%", pt: 11 }}>
                                                        <Typography sx={{ color: "white", textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h2">
                                                            Ваша история начинается здесь
                                                        </Typography>

                                                        <Typography sx={{ color: 'neutral.100', gap: 1, pt: 3, textAlign: "center" }} level="body-sm">
                                                            {NAME_PROJECT?.toUpperCase()} — это сообщество тех, кто верит в настоящие чувства. Найдите не только партнера, но и друзей, единомышленников, свою вторую половинку.<br/>Здесь знакомства перерастают в историю, а одиночество растворяется в единстве.
                                                        </Typography>
                                                    </Stack>
                                                </Stack> */}
                                                <Stack direction={"column"} alignItems={'center'} spacing={1} sx={{ width: "100%" }}>
                                                    <Button sx={{ width: "100%", px: 6, py: 1, fontSize: 'xl' }} onClick={handleCloseStartInfo}>
                                                        Начать
                                                    </Button>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    </Stack>
                                </SwiperSlide>
                            </Swiper>
                        </ModalDialog>
                    </ModalOverflow>
                </Modal>
            )}
        </AnimatePresence>
    );
}